"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const GavelIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { viewBox: "0 0 18 18", style: svgStyle, fill: "currentColor" },
            React.createElement("path", { d: "M11.7291 10.745L15.5051 14.61L14.5951 15.5L10.8291 11.645L7.38306 15.091L2.33105 10.039L10.2711 2.10001L15.3221 7.15201L11.7291 10.745V10.745ZM10.2701 3.71701L3.94805 10.039L7.38306 13.474L13.7061 7.15201L10.2701 3.71701Z" }))));
};
GavelIcon.displayName = 'GavelIcon';
exports.default = GavelIcon;
//# sourceMappingURL=GavelIcon.js.map